/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Already_Have_An_AccountInputs */

const en_already_have_an_account = /** @type {(inputs: Already_Have_An_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already have an account?`)
};

const es_already_have_an_account = /** @type {(inputs: Already_Have_An_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Ya tienes una cuenta?`)
};

const fr_already_have_an_account = /** @type {(inputs: Already_Have_An_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous avez déjà un compte ?`)
};

const de_already_have_an_account = /** @type {(inputs: Already_Have_An_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereits ein Konto?`)
};

const ja_already_have_an_account = /** @type {(inputs: Already_Have_An_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すでにアカウントをお持ちですか？`)
};

const zh_already_have_an_account = /** @type {(inputs: Already_Have_An_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已经有账号了？`)
};

const ar_already_have_an_account = /** @type {(inputs: Already_Have_An_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لديك حساب بالفعل؟`)
};

const id_already_have_an_account = /** @type {(inputs: Already_Have_An_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sudah punya akun?`)
};

const it_already_have_an_account = /** @type {(inputs: Already_Have_An_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai già un account?`)
};

const ru_already_have_an_account = /** @type {(inputs: Already_Have_An_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уже есть аккаунт?`)
};

const pt_already_have_an_account = /** @type {(inputs: Already_Have_An_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já tem uma conta?`)
};

const ko_already_have_an_account = /** @type {(inputs: Already_Have_An_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이미 계정이 있으신가요?`)
};

/**
* | output |
* | --- |
* | "Already have an account?" |
*
* @param {Already_Have_An_AccountInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const already_have_an_account = /** @type {((inputs?: Already_Have_An_AccountInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Already_Have_An_AccountInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_already_have_an_account(inputs)
	if (locale === "es") return es_already_have_an_account(inputs)
	if (locale === "fr") return fr_already_have_an_account(inputs)
	if (locale === "de") return de_already_have_an_account(inputs)
	if (locale === "ja") return ja_already_have_an_account(inputs)
	if (locale === "zh") return zh_already_have_an_account(inputs)
	if (locale === "ar") return ar_already_have_an_account(inputs)
	if (locale === "id") return id_already_have_an_account(inputs)
	if (locale === "it") return it_already_have_an_account(inputs)
	if (locale === "ru") return ru_already_have_an_account(inputs)
	if (locale === "pt") return pt_already_have_an_account(inputs)
	return ko_already_have_an_account(inputs)
});